import { render, staticRenderFns } from "./companyC3Config.vue?vue&type=template&id=30991b0c&"
import script from "./companyC3Config.vue?vue&type=script&lang=js&"
export * from "./companyC3Config.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports